// Можно добавить прямо в App.js или вынести в отдельный файл components/TelegramInitializer.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import {
    initTelegramDefaults,
    initBackButton,
    initSettingsButton,
    setHeaderColor, disableVerticalSwipes
} from '../services/telegramService'; // Импортируем функции

// Переменные цветов (лучше импортировать или получать из ThemeContext)
const THEME_COLORS = {
    light: { headerBg: '#F0F0F0', sectionBg: '#F0F0F0' },
    dark: { headerBg: '#121212', sectionBg: '#121212' }
};

function TelegramInitializer() {
    const navigate = useNavigate();
    const { theme } = useTheme();

    // Инициализация при монтировании
    useEffect(() => {
        // Инициализация базовых вещей
        initTelegramDefaults();

        disableVerticalSwipes();

        // Настройка обработчиков кнопок
        initBackButton(() => navigate(-1));
        initSettingsButton(() => navigate('/settings'));

        // Функция очистки не нужна здесь, т.к. сервис сам обрабатывает offEvent
        return () => {
            console.log("TelegramInitializer unmounting (should not happen often).");
        }

    }, []); // Зависимость от navigate (стабильна)

    // Эффект для обновления цвета хедера при смене темы
    useEffect(() => {
        const currentTheme = theme === 'dark' ? 'dark' : 'light';
        const headerColor = THEME_COLORS[currentTheme].headerBg; // Цвет контейнера
        if (headerColor) {
            setHeaderColor(headerColor);
        }
    }, [theme]); // Зависимость от темы

    return null; // Компонент ничего не рендерит
}

export default TelegramInitializer;
